import { render } from "./PublishAd.vue?vue&type=template&id=0107adc0&scoped=true"
import script from "./PublishAd.vue?vue&type=script&lang=js"
export * from "./PublishAd.vue?vue&type=script&lang=js"

import "./PublishAd.vue?vue&type=style&index=0&id=0107adc0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0107adc0"]])

export default __exports__